export default "__VITE_ASSET__c1e4e2b8__"